import React from 'react';

import {Marker} from 'common/components/BetterMap';
import odIcon from '../icons/od.svg';

const ODMarker = ({...props}) => (
  <Marker
    icon={{
      anchor: {x: 8, y: 8},
      size: {width: 16, height: 16},
      url: odIcon,
    }}
    {...props}
  />
);

export default ODMarker;



// WEBPACK FOOTER //
// ./src/ondemand/components/ODMarker.js